import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { createPassViewColumns } from "./pass-view-columns";
import { statusCalculationMethodData360LiveEnum } from "../../constants/commonConstants";
import { logDataHelperFunctions } from "../../helpers/logdata-helper";
import { passViewHelper } from "../../helpers/passzone/pass-zone-helper";
import { FETCH_PASS_VIEW_SAGA } from "../../redux/d360Live_Views/types";
import EnterpriseGridCommon from "../AgGrid/Ag-Grid";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useTranslation } from "react-i18next";
import ErrorBanner from "../Common/ErrorBanner";
import CommonLoader from "../Loaders/loader";

const Data360LivePassViewAgGrid = ({
  projectId,
  projectName,
  weldNumber,
  statusCalculationMethod,
  currentProject,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const state = useSelector((state) => state?.data360LiveViewsReducer);
  const [rows, setRows] = useState([]);

  const passViewData = state?.passView?.data || [];
  const conversionFactors = state?.passView?.conversionFactors;
  const decimalPlaces = state?.passView?.decimalPlaces;
  const weldParameterErrors = state?.passView?.weldParameterErrors;
  const isLoading = state?.isLoading?.passView;

  const getStringValue = (value) => (value ? String(value) : "");

  const createMeasurementObject = (item, prefix) => {
    const conversionFactor = conversionFactors?.[prefix] || 1;
    const decimalPlacesForField = decimalPlaces?.[prefix];

    console.log(decimalPlacesForField, prefix, item);
    return {
      low:
        getStringValue(
          item?.[`${prefix}_low`]
            ? (parseFloat(item?.[`${prefix}_low`]) * conversionFactor).toFixed(
                decimalPlacesForField
              )
            : ""
        ) + (item?.[`${prefix}_low_status`] === false ? "-color" : ""),
      avg:
        getStringValue(
          item?.[`${prefix}_avg`]
            ? (parseFloat(item?.[`${prefix}_avg`]) * conversionFactor).toFixed(
                decimalPlacesForField
              )
            : ""
        ) + (item?.[`${prefix}_avg_status`] === false ? "-color" : ""),
      high:
        getStringValue(
          item?.[`${prefix}_high`]
            ? (parseFloat(item?.[`${prefix}_high`]) * conversionFactor).toFixed(
                decimalPlacesForField
              )
            : ""
        ) + (item?.[`${prefix}_high_status`] === false ? "-color" : ""),
    };
  };

  const getStatusCalculationMethod = (statusCalculationMethod, record) => {
    switch (statusCalculationMethod) {
      case statusCalculationMethodData360LiveEnum.Instantaneous:
        return record.pass_status_by_instantaneous;
      case statusCalculationMethodData360LiveEnum.AvgByPass:
        return record.pass_avg_status;
      case statusCalculationMethodData360LiveEnum.AvgByZone:
      case statusCalculationMethodData360LiveEnum.AvgByTilt:
        return record.pass_staus_by_zone;
      default:
        return record.pass_status_by_instantaneous;
    }
  };

  useEffect(() => {
    if (projectId && projectName) {
      dispatch({
        type: FETCH_PASS_VIEW_SAGA,
        payload: {
          project_id: projectId,
          project_name: projectName,
          weld_number: weldNumber,
        },
      });
    }
  }, [dispatch, projectId, projectName, weldNumber]);

  useEffect(() => {
    if (passViewData && Array.isArray(passViewData)) {
      if (passViewData.length > 0) {
        const mappedData = passViewData?.map((item, index) => ({
          sl_no: index + 1,
          status:
            getStatusCalculationMethod(statusCalculationMethod, item) || "",
          s_deviceid_event: item?.welduid_s_event_torch || "",
          stationNumbers: logDataHelperFunctions.getStationName(
            item?.station_number
          ),
          //for tlog screen
          bug_number: item?.bug_number,
          band_diameter: item?.band_diameter
            ? (
                parseFloat(item.band_diameter) *
                (conversionFactors?.band_diameter || 1)
              ).toFixed(decimalPlaces?.band_diameter || 2)
            : "",
          wire_diameter: item?.wire_diameter
            ? (
                parseFloat(item.wire_diameter) *
                (conversionFactors?.wire_diameter || 1)
              ).toFixed(decimalPlaces?.wire_diameter || 2)
            : "",
          logging_distance: item?.logging_distance
            ? (
                parseFloat(item.logging_distance) *
                (conversionFactors?.logging_distance || 1)
              ).toFixed(decimalPlaces?.logging_distance || 2)
            : "",
          pipe_diameter: item?.pipe_diameter
            ? (
                parseFloat(item.pipe_diameter) *
                (conversionFactors?.pipe_diameter || 1)
              ).toFixed(decimalPlaces?.pipe_diameter || 2)
            : "",

          ///
          buyType: item?.bug_type || "",
          type: item?.torch || "",
          name: item?.pass_name || "",
          rawWeldStartTime: item?.s_time || "",
          end_time: item?.c_time || "",
          weld_time: item?.weld_time || "",
          autoIncrement: item?.auto_increment || "-",
          amps: createMeasurementObject(item, "current"),
          volts: createMeasurementObject(item, "volts"),
          travel: createMeasurementObject(item, "travel_speed"),
          heat: createMeasurementObject(item, "true_energy"),
          calculated: createMeasurementObject(item, "heat"),
          wire: createMeasurementObject(item, "wire_speed"),
          oscillate: createMeasurementObject(item, "oscillation_width"),
          frequency: createMeasurementObject(item, "frequency"),
          target: createMeasurementObject(item, "target"),
          horizontal: createMeasurementObject(item, "horizontal_bias"),
          total: createMeasurementObject(item, "total_wire_consumed"),
          arcImpedance: createMeasurementObject(item, "arc_impedance"),
          weld_uuid: item?.weld_uid || "",
        }));
        setRows(mappedData);
      } else {
        // Clear rows when data is empty
        setRows([]);
      }
    }
  }, [passViewData, conversionFactors, decimalPlaces]);

  const handleRowClick = (params) => {
    const record = params.data;
    history.push("/data360-live-tlog-data", {
      stationNumbers: record.stationNumbers,
      buyType: record.buyType,
      torch: record.type,
      weld_number: weldNumber,
      s_deviceid_event: record.s_deviceid_event,
      view: "Pass",

      //tlog display
      autoIncrement: record.autoIncrement,
      band_diameter: record.band_diameter,
      logging_distance: record.logging_distance,
      bug_number: record.bug_number,
      wire_diameter: record.wire_diameter,
      pipe_diameter: record.pipe_diameter,
      start_time: record.rawWeldStartTime,
      end_time: record.end_time,
      weld_time: record.weld_time,

      // gps: record.gps,
      // iwm: record.iwm,
      // isM500: record.isM500,
    });
  };

  const onRowClicked = (params) => {
    console.log("Row clicked", params);
    handleRowClick(params);
  };

  const processCellCallback = (params) => {
    if (params?.column?.colDef?.processCellForExport) {
      return params.column.colDef.processCellForExport(params);
    }
    return params.value;
  };

  console.log(
    currentProject,
    logDataHelperFunctions.data360LiveGetReportColumns(currentProject),
    "currentProject - Data360LivePassViewAgGrid"
  );

  // Extract error messages from weldParameterErrors
  const getErrorMessages = () => {
    if (
      !weldParameterErrors?.errors ||
      weldParameterErrors.errors.length === 0
    ) {
      return [];
    }

    const errorMessages = [];
    weldParameterErrors.errors.forEach((error) => {
      if (error.parsedErrors?.errorMessages) {
        errorMessages.push(...error.parsedErrors.errorMessages);
      }
    });

    return errorMessages;
  };

  const errorMessages = getErrorMessages();

  return (
    <div className="pass-zone">
      {isLoading ? (
        <div className="slogdata-loader">
          <CommonLoader />
        </div>
      ) : (
        <>
          <ErrorBanner errors={errorMessages} />
          {rows.length > 0 ? (
            <div className="ag-theme-alpine" style={{ width: "100%" }}>
              <EnterpriseGridCommon
                isLoading={isLoading}
                rows={rows}
                columnDefs={passViewHelper.mapPassViewColumns(
                  createPassViewColumns(t),
                  logDataHelperFunctions.data360LiveGetReportColumns(
                    currentProject
                  )
                )}
                onRowClicked={onRowClicked}
                exportFileName={"pass-view"}
                processCellCallback={processCellCallback}
                heightValue={-150}
              />
            </div>
          ) : (
            <div className="slog-NoData">
              <p>{t("sLogData.noDataAvailable")}</p>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Data360LivePassViewAgGrid;
